// src/components/AIAgent/TokenUsageIndicator.jsx

import React, { useEffect } from "react";
import { useAIAgentStore } from "../../services/useAIAgentStore";
import "./AIAgent.css";

const TokenUsageIndicator = () => {
  const { workspaceMetrics, fetchWorkspaceMetrics } = useAIAgentStore();

  useEffect(() => {
    if (!workspaceMetrics) {
      fetchWorkspaceMetrics();
    }
  }, []);

  const formatTokens = (tokens) => {
    if (!tokens) return "0";
    if (tokens >= 1000000) {
      return `${(tokens / 1000000).toFixed(1)}M`;
    }
    if (tokens >= 1000) {
      return `${(tokens / 1000).toFixed(1)}k`;
    }
    return tokens.toString();
  };

  const totalTokens = (workspaceMetrics?.messages?.prompt_tokens || 0) +
    (workspaceMetrics?.messages?.completion_tokens || 0);

  const tokensSaved = workspaceMetrics?.summaries?.tokens_saved || 0;

  const savingsPercent = totalTokens > 0
    ? Math.round((tokensSaved / (totalTokens + tokensSaved)) * 100)
    : 0;

  return (
    <div className="token-usage-indicator">
      <div className="token-stat">
        <span className="token-icon">T</span>
        <div className="token-info">
          <span className="token-value">{formatTokens(totalTokens)}</span>
          <span className="token-label">tokens usados</span>
        </div>
      </div>

      <div className="token-divider" />

      <div className="token-stat savings">
        <div className="token-info">
          <span className="token-value success">{formatTokens(tokensSaved)}</span>
          <span className="token-label">tokens salvos ({savingsPercent}%)</span>
        </div>
      </div>

      {workspaceMetrics && (
        <div className="token-tooltip">
          <div className="tooltip-row">
            <span>Tokens de prompt:</span>
            <span>{formatTokens(workspaceMetrics.messages?.prompt_tokens)}</span>
          </div>
          <div className="tooltip-row">
            <span>Tokens de resposta:</span>
            <span>{formatTokens(workspaceMetrics.messages?.completion_tokens)}</span>
          </div>
          <div className="tooltip-row">
            <span>Total de mensagens:</span>
            <span>{workspaceMetrics.messages?.total || 0}</span>
          </div>
          <div className="tooltip-row">
            <span>Resumos gerados:</span>
            <span>{workspaceMetrics.summaries?.total || 0}</span>
          </div>
          <div className="tooltip-row highlight">
            <span>Economia com resumos:</span>
            <span>{formatTokens(tokensSaved)} tokens</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TokenUsageIndicator;
